<template>
  <header class="header border-gris-bordure border-b 2md:justify-between	">
    <button
      class="menu-btn"
      :class="{ 'is-open': mainMenuDisplay }"
      @click="$emit('update:mainMenuDisplay', !mainMenuDisplay)"
    ></button>

    <div class="main-search">
      <input
        v-model="generalSearchTerm"
        v-on:keyup.enter="generalSearch()"
        type="search"
        id="#main-search"
        placeholder="Rechercher dans tout le site"
        class="pl-2"
      />
    </div>
    <div
      class="
        flex
        justify-center
        md:w-2/6		
       items-center	
      "
    >
      <head-title small />
    </div>

    <div v-if="authenticated" class="user-menu border-l border-gris-bordure" >
      <div class="user-menu_name sm:order-1 order-2">
        <router-link :to="{ name: 'compte' }" title="Informations du compte">
        <!-- <a href="" @click="$router.push({ name: 'compte' })"> -->
          <span class="user-menu_name_text">{{ username }}</span>
        <!-- </a> -->
        </router-link>
        <ul class="user-menu_pref" :class="{ 'is-open': userMenuDisplay }">
          <li
            class="user-menu_pref_item user-menu_pref_close mobile-only"
            @click="toggleUserMenu"
          >
            <span class="close"></span>
          </li>
          <li
            class="user-menu_pref_item user-menu_pref_name no-event mobile-only"
          >
            Mes infos
          </li>
          <!-- <li class="user-menu_pref_item">
            <router-link
              @click.native="toggleUserMenu"
              :to="{ name: 'favorites' }"
              title="Accèder à votre liste de favoris"
            >
              Mes favoris et alertes
            </router-link>
          </li>
          <li class="user-menu_pref_item">
            <router-link
              @click.native="toggleUserMenu"
              :to="{ name: 'savedSearches' }"
              title="Accèder à votre liste de recherches"
            >
              Mes recherches
            </router-link>
          </li> -->
          <hr class="mobile-only" />
          <li class="user-menu_pref_item mobile-only" @click="disconnect()">
            <a title="Se déconnecter">Déconnexion</a>
          </li>
        </ul>
      </div>
      <div class="user-menu_fav sm:order-2 order-1">
        <router-link
          :to="{ name: 'favorites' }"
          title="Accèder à votre liste de favoris"
        >
          <img src="@/assets/images/fav.svg" alt="favoris" />
        </router-link>
      </div>
      <div class="user-menu_log order-3 sm:border-none border-l border-gray-400" @click="disconnect()">
        <a title="Se déconnecter">
          <img src="@/assets/images/login.svg" alt="Icône de déconnexion" />
        </a>
      </div>
    </div>

    <div v-else class="authent-menu">
      <div>
        <button
          class="authent-menu_login orange-background"
          @click="$router.push({ name: 'login' })"
        >
          Connexion
        </button>
      </div>
    </div>
  </header>
</template>

<script>
import { mapState } from "vuex";
import HeadTitle from "./HeadTitle.vue";

export default {
  name: "HeadBar",
  components: {
    HeadTitle,
  },
  props: {
    mainMenuDisplay: Boolean,
  },

  data() {
    return {
      userMenuDisplay: false,
      generalSearchTerm: "",
    };
  },

  methods: {
    toggleUserMenu() {
      this.userMenuDisplay = !this.userMenuDisplay;
    },

    disconnect() {
      this.$store.commit("authent/disconnect");
      this.$router.push({
        name: "login",
      });
    },

    generalSearch() {
      if (this.generalSearchTerm) {
        this.$router.push({
          name: "generalSearch",
          query: {
            terms: this.generalSearchTerm,
          },
        });
        this.$gtag.event('search', { event_category: 'recherche générale',search_term: this.generalSearchTerm })
        this.generalSearchTerm = "";
      }
    },
  },

  computed: {
    ...mapState("authent", {
      username: (state) => state.user.full_name,
    }),
    authenticated() {
      return this.$store.getters["authent/isAuthenticated"];
    },
    hasActiveSubscription () {
      return this.$store.getters['authent/hasActiveSubscription']
    }
  },
};
</script>
